import { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Edit } from "@mui/icons-material";
import PropTypes from "prop-types";

import { useToaster } from "hooks";
import { error } from "constants";

const EditableView = ({
  lineItemData = "",
  doId,
  onEditDoQty,
  isApproveRejectRefreshAction,
}) => {
  const [value, setValue] = useState(lineItemData?.lineItemDoQuantity);
  const [editable, setEditable] = useState(false);

  const triggerToaster = useToaster();

  const handleEditClick = () => {
    setEditable(true);
  };

  const handleChange = (e) => {
    if (e.target.value <= lineItemData?.lineItemFgQuantity) {
      setValue(e.target.value);
    } else {
      triggerToaster(
        "Input value should be less than or equal to FG quantity",
        error,
      );
    }
  };

  const handleBlur = () => {
    setEditable(false);
    onEditDoQty?.(value, lineItemData?.lineItemId, doId);
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant="outlined"
      size="small"
      disabled={!editable}
      sx={{
        width: "150px",
      }}
      type="number"
      InputProps={{
        endAdornment: !isApproveRejectRefreshAction ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={handleEditClick}
              edge="end"
              tabIndex={-1} // prevents focusing when tabbing
            >
              <Edit fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default EditableView;

EditableView.propTypes = {
  lineItemData: PropTypes.object,
  onEditDoQty: PropTypes.func,
};
